module.exports = __webpack_public_path__ + "img/toll-blue-fill-with-cross.ce5d1492.svg";